import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export function selectHypothesisFrame(state: RootState) {
  return state.messages.hypothesisFrame;
}

const selectMessages = (state: RootState) => state.messages;
const selectIsAIActive = createSelector(
  selectMessages,
  (messages) => messages.isAIActive
);
const selectIsWebSocketConnected = createSelector(
  selectMessages,
  (messages) => messages.isConnected
);
const selectIsNewSession = createSelector(
  selectMessages,
  (messages) => messages.isNewSession
);
const selectRestaurantStaffIntervention = createSelector(
  selectMessages,
  (messages) => messages.restaurantStaffIntervention
);
const selectIsStaffIntervention = createSelector(
  selectMessages,
  (messages) => messages.isStaffIntervention
);
const selectIsPlaying = createSelector(
  selectMessages,
  (messages) => messages.isPlaying
);
const selectAsrcPlayer = createSelector(
  selectMessages,
  (messages) => messages.asrcPlayer
);
const selectCurrentSessionId = createSelector(
  selectMessages,
  (messages) => messages.currentSessionId
);
const selectIsStaffIntervenedBeforeCarExit = createSelector(
  selectMessages,
  (messages) => messages.isStaffIntervenedBeforeCarExit
);

const selectFinalTextFrames = createSelector(
  selectMessages,
  (messages) => messages.finalTextFrames
);
const selectInProgressHypothesisTextFrames = createSelector(
  selectMessages,
  (messages) => messages.inProgressHypothesisTextFrames
);
const selectSentTextFrames = createSelector(
  selectMessages,
  (messages) => messages.sentTextFrames
);

const selectSBFinalTextFrames = createSelector(
  selectMessages,
  (messages) => messages.sbFinalTextFrames
);
const selectSBInProgressHypothesisTextFrames = createSelector(
  selectMessages,
  (messages) => messages.sbInProgressHypothesisTextFrames
);
const selectIsCarPresent = createSelector(
  selectMessages,
  (messages) => messages.isCarPresent
);

const selectEntityAnnotationsMap = createSelector(
  selectMessages,
  (messages) => messages.entityAnnotationsMap
);

export {
  selectAsrcPlayer,
  selectCurrentSessionId,
  selectFinalTextFrames,
  selectInProgressHypothesisTextFrames,
  selectIsAIActive,
  selectIsNewSession,
  selectIsPlaying,
  selectIsStaffIntervenedBeforeCarExit,
  selectIsStaffIntervention,
  selectIsWebSocketConnected,
  selectRestaurantStaffIntervention,
  selectSBFinalTextFrames,
  selectSBInProgressHypothesisTextFrames,
  selectSentTextFrames,
  selectIsCarPresent,
  selectEntityAnnotationsMap,
};
